<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title mb-1">Dashboard Thu Chi</h3>
            <ul class="breadcrumb mb-0">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Thu Chi - Quản lý</li>
            </ul>
          </div>
          <div class="col-auto d-flex align-items-center mt-3 mt-md-0">
            <div class="mr-2">
              <select
                class="form-control"
                v-model.number="filters.nam"
              >
                <option v-for="y in yearOptions" :key="y" :value="y">
                  {{ y }}
                </option>
              </select>
            </div>
            <div class="mr-2">
              <select
                class="form-control"
                v-model.number="filters.thang"
              >
                <option
                  v-for="m in monthOptions"
                  :key="m.value"
                  :value="m.value"
                >
                  {{ m.label }}
                </option>
              </select>
            </div>
            <div class="mr-2">
              <select
                class="form-control d-none d-md-block"
                v-model="filters.idPhongBan"
              >
                <option :value="null">Tất cả phòng ban</option>
                <option
                  v-for="pb in phongBanOptions"
                  :key="pb.idPhongBan"
                  :value="pb.idPhongBan"
                >
                  {{ pb.tenPhongBan }}
                </option>
              </select>
            </div>
            <button
              class="btn btn-white d-inline-flex align-items-center"
              @click="reloadAll"
            >
              <i class="fa fa-refresh mr-1"></i> Tải lại
            </button>
          </div>
        </div>

        <!-- Phòng ban selector (mobile) -->
        <div class="row mt-3 d-md-none">
          <div class="col-12">
            <select
              class="form-control"
              v-model="filters.idPhongBan"
            >
              <option :value="null">Tất cả phòng ban</option>
              <option
                v-for="pb in phongBanOptions"
                :key="pb.idPhongBan"
                :value="pb.idPhongBan"
              >
                {{ pb.tenPhongBan }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <!-- Loading overlay -->
      <div v-if="loading.global" class="mt-2 mb-3">
        <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
        Đang tải dữ liệu...
      </div>

      <!-- Tổng quan tiền -->
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3 mb-3">
          <div class="card mini-stat bg-primary text-white h-100">
            <div class="card-body d-flex flex-column">
              <div class="mb-1 d-flex justify-content-between align-items-center">
                <span class="text-uppercase font-size-12">Tổng Chi tháng</span>
                <i class="fa fa-arrow-down"></i>
              </div>
              <h4 class="mb-1">{{ formatCurrency(dashboard?.tongChiThang) }}</h4>
              <span class="text-white-50 font-size-12 mt-auto">
                Bao gồm mọi khoản chi được duyệt trong tháng
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-3 mb-3">
          <div class="card mini-stat bg-success text-white h-100">
            <div class="card-body d-flex flex-column">
              <div class="mb-1 d-flex justify-content-between align-items-center">
                <span class="text-uppercase font-size-12">Tổng Thu tháng</span>
                <i class="fa fa-arrow-up"></i>
              </div>
              <h4 class="mb-1">{{ formatCurrency(dashboard?.tongThuThang) }}</h4>
              <span class="text-white-50 font-size-12 mt-auto">
                Bao gồm tạm ứng, thu hộ, hoàn trả...
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-3 mb-3">
          <div class="card mini-stat bg-info text-white h-100">
            <div class="card-body d-flex flex-column">
              <div class="mb-1 d-flex justify-content-between align-items-center">
                <span class="text-uppercase font-size-12">Công ty nợ nhân viên</span>
                <i class="fa fa-user-o"></i>
              </div>
              <h4 class="mb-1">{{ formatCurrency(dashboard?.tongCongTyNoNhanVien) }}</h4>
              <span class="text-white-50 font-size-12 mt-auto">
                Chi đã duyệt, chưa trả hoặc chưa quyết toán qua lương
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-3 mb-3">
          <div class="card mini-stat bg-danger text-white h-100">
            <div class="card-body d-flex flex-column">
              <div class="mb-1 d-flex justify-content-between align-items-center">
                <span class="text-uppercase font-size-12">Nhân viên nợ công ty</span>
                <i class="fa fa-building-o"></i>
              </div>
              <h4 class="mb-1">{{ formatCurrency(dashboard?.tongNhanVienNoCongTy) }}</h4>
              <span class="text-white-50 font-size-12 mt-auto">
                Tạm ứng, thu hộ đã duyệt, chưa hoàn trả hoặc quyết toán
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Thống kê trạng thái + Aging -->
      <div class="row">
        <div class="col-12 col-lg-8 mb-3">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Trạng thái phiếu</h5>
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-6 col-md-4 mb-3">
                  <div class="status-pill bg-soft-warning">
                    <div class="status-label">
                      <i class="fa fa-hourglass-half mr-1 text-warning"></i> Chờ duyệt
                    </div>
                    <div class="status-value">
                      {{ dashboard?.soPhieuChoDuyet ?? 0 }}
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-4 mb-3">
                  <div class="status-pill bg-soft-info">
                    <div class="status-label">
                      <i class="fa fa-check-circle-o mr-1 text-info"></i> Đã duyệt
                    </div>
                    <div class="status-value">
                      {{ dashboard?.soPhieuDaDuyet ?? 0 }}
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-4 mb-3">
                  <div class="status-pill bg-soft-success">
                    <div class="status-label">
                      <i class="fa fa-money mr-1 text-success"></i> Đã thanh toán
                    </div>
                    <div class="status-value">
                      {{ dashboard?.soPhieuDaThanhToan ?? 0 }}
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-4 mb-3">
                  <div class="status-pill bg-soft-primary">
                    <div class="status-label">
                      <i class="fa fa-check-square-o mr-1 text-primary"></i> Đã quyết toán lương
                    </div>
                    <div class="status-value">
                      {{ dashboard?.soPhieuDaQuyetToan ?? 0 }}
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-4 mb-3">
                  <div class="status-pill bg-soft-danger">
                    <div class="status-label">
                      <i class="fa fa-times mr-1 text-danger"></i> Từ chối
                    </div>
                    <div class="status-value">
                      {{ dashboard?.soPhieuTuChoi ?? 0 }}
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-4 mb-3">
                  <div class="status-pill bg-soft-secondary">
                    <div class="status-label">
                      <i class="fa fa-random mr-1 text-secondary"></i> Qua lương / Thanh toán ngay
                    </div>
                    <div class="status-value small">
                      Qua lương: {{ dashboard?.soPhieuQuaLuong ?? 0 }}<br />
                      Thanh toán ngay: {{ dashboard?.soPhieuThanhToanNgay ?? 0 }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right mt-2">
                <small class="text-muted">
                  Tháng {{ filters.thang }}/{{ filters.nam }}
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- Aging -->
        <div class="col-12 col-lg-4 mb-3">
          <div class="card h-100">
            <div class="card-header">
              <h5 class="card-title mb-0">Phiếu đã duyệt nhưng treo xử lý</h5>
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-4">
                  <div class="aging-pill aging-7">
                    <div class="aging-label">≥ 7 ngày</div>
                    <div class="aging-value">
                      {{ dashboard?.soPhieuQuaHan7Ngay ?? 0 }}
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="aging-pill aging-15">
                    <div class="aging-label">≥ 15 ngày</div>
                    <div class="aging-value">
                      {{ dashboard?.soPhieuQuaHan15Ngay ?? 0 }}
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="aging-pill aging-30">
                    <div class="aging-label">≥ 30 ngày</div>
                    <div class="aging-value">
                      {{ dashboard?.soPhieuQuaHan30Ngay ?? 0 }}
                    </div>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 small text-muted text-center">
                Chỉ tính các phiếu đã duyệt, chưa thanh toán / chưa quyết toán lương
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Luồng nghiệp vụ A/B -->
      <div class="row">
        <div class="col-12 col-lg-6 mb-3">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Luồng CHI – Nhân viên bỏ tiền túi
              </h5>
            </div>
            <div class="card-body flow-body">
              <div class="flow-step">
                <div class="flow-title">
                  <span class="badge badge-pill badge-warning mr-1">Bước 1</span>
                  Tạo phiếu CHI
                </div>
                <div class="flow-row">
                  <div class="flow-box pending">
                    <div class="flow-label">Chờ duyệt</div>
                    <div class="flow-money">{{ formatCurrency(flow?.chi?.chiChoDuyet?.tongSoTien) }}</div>
                    <div class="flow-count">
                      {{ flow?.chi?.chiChoDuyet?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                  <div class="flow-box rejected">
                    <div class="flow-label">Từ chối</div>
                    <div class="flow-money">{{ formatCurrency(flow?.chi?.chiTuChoi?.tongSoTien) }}</div>
                    <div class="flow-count">
                      {{ flow?.chi?.chiTuChoi?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                </div>
              </div>

              <div class="flow-arrow">
                <i class="fa fa-long-arrow-down"></i>
              </div>

              <div class="flow-step">
                <div class="flow-title">
                  <span class="badge badge-pill badge-info mr-1">Bước 2</span>
                  Kế toán duyệt – Công ty nợ NV
                </div>
                <div class="flow-row">
                  <div class="flow-box flow-split">
                    <div class="flow-label">
                      Qua lương
                      <span class="badge badge-light ml-1">DA_DUYET</span>
                    </div>
                    <div class="flow-money">
                      {{ formatCurrency(flow?.chi?.chiDaDuyetQuaLuong?.tongSoTien) }}
                    </div>
                    <div class="flow-count">
                      {{ flow?.chi?.chiDaDuyetQuaLuong?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                  <div class="flow-box flow-split">
                    <div class="flow-label">
                      Trả nóng
                      <span class="badge badge-light ml-1">DA_DUYET</span>
                    </div>
                    <div class="flow-money">
                      {{ formatCurrency(flow?.chi?.chiDaDuyetTraNong?.tongSoTien) }}
                    </div>
                    <div class="flow-count">
                      {{ flow?.chi?.chiDaDuyetTraNong?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                </div>
              </div>

              <div class="flow-arrow">
                <i class="fa fa-long-arrow-down"></i>
              </div>

              <div class="flow-step">
                <div class="flow-title">
                  <span class="badge badge-pill badge-success mr-1">Bước 3</span>
                  Thanh toán / Quyết toán
                </div>
                <div class="flow-row">
                  <div class="flow-box done">
                    <div class="flow-label">
                      Cộng vào lương
                      <span class="badge badge-light ml-1">DA_QUYET_TOAN</span>
                    </div>
                    <div class="flow-money">
                      {{ formatCurrency(flow?.chi?.chiDaQuyetToanQuaLuong?.tongSoTien) }}
                    </div>
                    <div class="flow-count">
                      {{ flow?.chi?.chiDaQuyetToanQuaLuong?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                  <div class="flow-box done">
                    <div class="flow-label">
                      Trả nóng xong
                      <span class="badge badge-light ml-1">DA_THANH_TOAN</span>
                    </div>
                    <div class="flow-money">
                      {{ formatCurrency(flow?.chi?.chiDaThanhToanTraNong?.tongSoTien) }}
                    </div>
                    <div class="flow-count">
                      {{ flow?.chi?.chiDaThanhToanTraNong?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                </div>
              </div>

              <p class="mt-3 mb-0 small text-muted">
                Dữ liệu theo tháng {{ filters.thang }}/{{ filters.nam }}{{ phongBanSuffix }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6 mb-3">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                Luồng THU – Tạm ứng / Thu hộ
              </h5>
            </div>
            <div class="card-body flow-body">
              <div class="flow-step">
                <div class="flow-title">
                  <span class="badge badge-pill badge-warning mr-1">Bước 1</span>
                  Tạo phiếu THU
                </div>
                <div class="flow-row">
                  <div class="flow-box pending">
                    <div class="flow-label">Chờ duyệt</div>
                    <div class="flow-money">{{ formatCurrency(flow?.thu?.thuChoDuyet?.tongSoTien) }}</div>
                    <div class="flow-count">
                      {{ flow?.thu?.thuChoDuyet?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                  <div class="flow-box rejected">
                    <div class="flow-label">Từ chối</div>
                    <div class="flow-money">{{ formatCurrency(flow?.thu?.thuTuChoi?.tongSoTien) }}</div>
                    <div class="flow-count">
                      {{ flow?.thu?.thuTuChoi?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                </div>
              </div>

              <div class="flow-arrow">
                <i class="fa fa-long-arrow-down"></i>
              </div>

              <div class="flow-step">
                <div class="flow-title">
                  <span class="badge badge-pill badge-info mr-1">Bước 2</span>
                  Kế toán xác nhận – NV nợ công ty
                </div>
                <div class="flow-row">
                  <div class="flow-box flow-split">
                    <div class="flow-label">
                      Trừ lương
                      <span class="badge badge-light ml-1">DA_DUYET</span>
                    </div>
                    <div class="flow-money">
                      {{ formatCurrency(flow?.thu?.thuDaDuyetTruLuong?.tongSoTien) }}
                    </div>
                    <div class="flow-count">
                      {{ flow?.thu?.thuDaDuyetTruLuong?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                  <div class="flow-box flow-split">
                    <div class="flow-label">
                      Nộp lại ngay
                      <span class="badge badge-light ml-1">DA_DUYET</span>
                    </div>
                    <div class="flow-money">
                      {{ formatCurrency(flow?.thu?.thuDaDuyetNopNgay?.tongSoTien) }}
                    </div>
                    <div class="flow-count">
                      {{ flow?.thu?.thuDaDuyetNopNgay?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                </div>
              </div>

              <div class="flow-arrow">
                <i class="fa fa-long-arrow-down"></i>
              </div>

              <div class="flow-step">
                <div class="flow-title">
                  <span class="badge badge-pill badge-success mr-1">Bước 3</span>
                  Hoàn trả / Quyết toán
                </div>
                <div class="flow-row">
                  <div class="flow-box done">
                    <div class="flow-label">
                      Đã trừ lương
                      <span class="badge badge-light ml-1">DA_QUYET_TOAN</span>
                    </div>
                    <div class="flow-money">
                      {{ formatCurrency(flow?.thu?.thuDaQuyetToanTruLuong?.tongSoTien) }}
                    </div>
                    <div class="flow-count">
                      {{ flow?.thu?.thuDaQuyetToanTruLuong?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                  <div class="flow-box done">
                    <div class="flow-label">
                      Đã nộp lại
                      <span class="badge badge-light ml-1">DA_THANH_TOAN</span>
                    </div>
                    <div class="flow-money">
                      {{ formatCurrency(flow?.thu?.thuDaThanhToanNopNgay?.tongSoTien) }}
                    </div>
                    <div class="flow-count">
                      {{ flow?.thu?.thuDaThanhToanNopNgay?.soPhieu ?? 0 }} phiếu
                    </div>
                  </div>
                </div>
              </div>

              <p class="mt-3 mb-0 small text-muted">
                Dữ liệu theo tháng {{ filters.thang }}/{{ filters.nam }}{{ phongBanSuffix }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Biểu đồ theo ngày + bảng phòng ban + top nhân viên -->
      <div class="row">
        <div class="col-12 col-xl-6 mb-3">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Chi / Thu theo ngày</h5>
            </div>
            <div class="card-body">
              <div v-if="!dailySummary.length" class="text-muted small">
                Chưa có dữ liệu trong tháng này.
              </div>
              <canvas
                v-else
                ref="dailyChartRef"
                style="max-height: 280px; width: 100%;"
              ></canvas>
              <p class="mt-2 mb-0 small text-muted">
                Dữ liệu tổng hợp theo ngày{{ phongBanSuffix }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-6 mb-3">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Theo phòng ban</h5>
            </div>
            <div class="card-body table-responsive">
              <table class="table table-sm table-hover mb-0">
                <thead>
                  <tr>
                    <th>Phòng ban</th>
                    <th class="text-right">Tổng Chi</th>
                    <th class="text-right">Tổng Thu</th>
                    <th class="text-right">Cty nợ NV</th>
                    <th class="text-right">NV nợ cty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!deptSummary.length">
                    <td colspan="5" class="text-center text-muted small">
                      Chưa có dữ liệu.
                    </td>
                  </tr>
                  <tr v-for="d in deptSummary" :key="d.idPhongBan">
                    <td>{{ d.tenPhongBan || 'Không xác định' }}</td>
                    <td class="text-right">
                      {{ formatCurrency(d.tongChi) }}
                    </td>
                    <td class="text-right">
                      {{ formatCurrency(d.tongThu) }}
                    </td>
                    <td class="text-right">
                      {{ formatCurrency(d.congTyNoNhanVien) }}
                    </td>
                    <td class="text-right">
                      {{ formatCurrency(d.nhanVienNoCongTy) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="mt-2 mb-0 small text-muted">
                Tổng hợp theo phòng ban toàn công ty.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Top nhân viên -->
      <div class="row">
        <div class="col-12 mb-3">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">Top nhân viên theo Thu Chi</h5>
            </div>
            <div class="card-body table-responsive">
              <table class="table table-sm table-hover mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nhân viên</th>
                    <th class="text-right">Tổng Chi</th>
                    <th class="text-right">Tổng Thu</th>
                    <th class="text-right">Cty nợ NV</th>
                    <th class="text-right">NV nợ cty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!userSummary.length">
                    <td colspan="6" class="text-center text-muted small">
                      Chưa có dữ liệu.
                    </td>
                  </tr>
                  <tr
                    v-for="(u, idx) in userSummary"
                    :key="u.idNguoiDung || idx"
                  >
                    <td>{{ idx + 1 }}</td>
                    <td>{{ u.tenNguoiDung || 'Không rõ' }}</td>
                    <td class="text-right">
                      {{ formatCurrency(u.tongChi) }}
                    </td>
                    <td class="text-right">
                      {{ formatCurrency(u.tongThu) }}
                    </td>
                    <td class="text-right">
                      {{ formatCurrency(u.congTyNoNhanVien) }}
                    </td>
                    <td class="text-right">
                      {{ formatCurrency(u.nhanVienNoCongTy) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="mt-2 mb-0 small text-muted">
                Dùng để nhận diện ai chi nhiều, ai đang nợ / được nợ.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  onMounted,
  watch,
  computed,
  onBeforeUnmount,
} from "vue";
import api from "@/api/index.js";
import { useToast } from "vue-toastification";
import Chart from "chart.js/auto";

const toast = useToast();

/* ---------------------- State & options ---------------------- */

const today = new Date();
const filters = reactive({
  thang: today.getMonth() + 1,
  nam: today.getFullYear(),
  idPhongBan: null,
});

const monthOptions = [
  { value: 1, label: "Tháng 1" },
  { value: 2, label: "Tháng 2" },
  { value: 3, label: "Tháng 3" },
  { value: 4, label: "Tháng 4" },
  { value: 5, label: "Tháng 5" },
  { value: 6, label: "Tháng 6" },
  { value: 7, label: "Tháng 7" },
  { value: 8, label: "Tháng 8" },
  { value: 9, label: "Tháng 9" },
  { value: 10, label: "Tháng 10" },
  { value: 11, label: "Tháng 11" },
  { value: 12, label: "Tháng 12" },
];

const yearOptions = [];
for (let y = today.getFullYear() - 2; y <= today.getFullYear() + 2; y++) {
  yearOptions.push(y);
}

const phongBanOptions = ref([]);

const dashboard = ref(null);
const flow = ref(null);
const dailySummary = ref([]);
const deptSummary = ref([]);
const userSummary = ref([]);

const loading = reactive({
  global: false,
});

/* ------------------------- Chart ------------------------- */

const dailyChartRef = ref(null);
let dailyChartInstance = null;

function destroyDailyChart() {
  if (dailyChartInstance) {
    dailyChartInstance.destroy();
    dailyChartInstance = null;
  }
}

function renderDailyChart() {
  destroyDailyChart();
  if (!dailyChartRef.value || !dailySummary.value.length) return;

  const ctx = dailyChartRef.value.getContext("2d");
  const labels = dailySummary.value.map((d) => d.ngay);
  const chiData = dailySummary.value.map((d) => toNumber(d.tongChi));
  const thuData = dailySummary.value.map((d) => toNumber(d.tongThu));

  dailyChartInstance = new Chart(ctx, {
    type: "line",
    data: {
      labels,
      datasets: [
        {
          label: "Tổng Chi",
          data: chiData,
          tension: 0.3,
          borderWidth: 2,
          pointRadius: 2,
        },
        {
          label: "Tổng Thu",
          data: thuData,
          tension: 0.3,
          borderWidth: 2,
          pointRadius: 2,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        mode: "index",
        intersect: false,
      },
      plugins: {
        legend: {
          display: true,
          position: "bottom",
        },
        tooltip: {
          callbacks: {
            label(context) {
              const label = context.dataset.label || "";
              const value = context.parsed.y || 0;
              return `${label}: ${formatCurrency(value)}`;
            },
          },
        },
      },
      scales: {
        x: {
          ticks: {
            maxTicksLimit: 7,
          },
        },
        y: {
          ticks: {
            callback: (val) => formatShortCurrency(val),
          },
        },
      },
    },
  });
}

/* ------------------------- Load API ------------------------- */

async function loadPhongBanOptions() {
  try {
    const res = await api.get("/api/phong-ban/options");
    // ApiResponse wrapper: { code, message, data }
    phongBanOptions.value = res.data?.data || [];
  } catch (e) {
    toast.error("Không tải được danh sách phòng ban");
  }
}

async function loadDashboard() {
  const params = {
    thang: filters.thang,
    nam: filters.nam,
  };
  const res = await api.get("/api/thu-chi/admin/dashboard", { params });
  dashboard.value = res.data;
}

async function loadFlow() {
  const params = {
    thang: filters.thang,
    nam: filters.nam,
  };
  if (filters.idPhongBan) {
    params.idPhongBan = filters.idPhongBan;
  }
  const res = await api.get("/api/thu-chi/admin/flow-summary", { params });
  flow.value = res.data;
}

async function loadDailySummary() {
  const params = {
    thang: filters.thang,
    nam: filters.nam,
  };
  if (filters.idPhongBan) {
    params.idPhongBan = filters.idPhongBan;
  }
  const res = await api.get("/api/thu-chi/admin/summary-by-day", { params });
  dailySummary.value = res.data || [];
}

async function loadDeptSummary() {
  const params = {
    thang: filters.thang,
    nam: filters.nam,
  };
  const res = await api.get("/api/thu-chi/admin/summary-by-dept", { params });
  deptSummary.value = res.data || [];
}

async function loadUserSummary() {
  const params = {
    thang: filters.thang,
    nam: filters.nam,
  };
  if (filters.idPhongBan) {
    params.idPhongBan = filters.idPhongBan;
  }
  const res = await api.get("/api/thu-chi/admin/summary-by-user", { params });
  userSummary.value = (res.data || []).slice(0, 20);
}

async function reloadAll() {
  loading.global = true;
  try {
    await Promise.all([
      loadDashboard(),
      loadFlow(),
      loadDailySummary(),
      loadDeptSummary(),
      loadUserSummary(),
    ]);
    renderDailyChart();
  } catch (e) {
    console.error(e);
    toast.error("Lỗi khi tải dữ liệu dashboard Thu Chi");
  } finally {
    loading.global = false;
  }
}

/* ------------------------- Utils ------------------------- */

function toNumber(val) {
  if (val === null || val === undefined) return 0;
  if (typeof val === "number") return val;
  const n = Number(val);
  return Number.isNaN(n) ? 0 : n;
}

function formatCurrency(val) {
  const n = toNumber(val);
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(n);
}

function formatShortCurrency(val) {
  const n = toNumber(val);
  if (n >= 1_000_000_000) {
    return (n / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  }
  if (n >= 1_000_000) {
    return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (n >= 1_000) {
    return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return n.toString();
}

const phongBanSuffix = computed(() => {
  const id = filters.idPhongBan;
  if (!id) return "";
  const pb = phongBanOptions.value.find((x) => x.idPhongBan === id);
  return pb ? ` – Phòng ${pb.tenPhongBan}` : "";
});

/* ------------------------- Lifecycle ------------------------- */

onMounted(async () => {
  await loadPhongBanOptions();
  await reloadAll();
});

watch(
  () => ({ ...filters }),
  () => {
    reloadAll();
  },
  { deep: true }
);

onBeforeUnmount(() => {
  destroyDailyChart();
});
</script>

<style scoped>
.page-title {
  font-size: 1.25rem;
  font-weight: 600;
}

.mini-stat {
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(15, 34, 58, 0.12);
}

.status-pill {
  border-radius: 0.75rem;
  padding: 0.6rem 0.5rem;
  background-color: #f8f9fa;
}

.status-label {
  font-size: 0.78rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.status-value {
  font-size: 1.1rem;
  font-weight: 600;
}

.bg-soft-warning {
  background-color: rgba(255, 193, 7, 0.12);
}

.bg-soft-info {
  background-color: rgba(23, 162, 184, 0.12);
}

.bg-soft-success {
  background-color: rgba(40, 167, 69, 0.12);
}

.bg-soft-primary {
  background-color: rgba(0, 123, 255, 0.12);
}

.bg-soft-danger {
  background-color: rgba(220, 53, 69, 0.12);
}

.bg-soft-secondary {
  background-color: rgba(108, 117, 125, 0.12);
}

/* Aging pills */
.aging-pill {
  border-radius: 0.75rem;
  padding: 0.55rem 0.3rem;
  background-color: #f8f9fa;
}

.aging-label {
  font-size: 0.75rem;
  color: #777;
}

.aging-value {
  font-size: 1.1rem;
  font-weight: 600;
}

.aging-7 {
  border-top: 3px solid #ffc107;
}

.aging-15 {
  border-top: 3px solid #fd7e14;
}

.aging-30 {
  border-top: 3px solid #dc3545;
}

/* Flow */
.flow-body {
  font-size: 0.85rem;
}

.flow-step {
  margin-bottom: 0.75rem;
}

.flow-title {
  font-weight: 600;
  margin-bottom: 0.35rem;
}

.flow-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.flow-box {
  flex: 1 1 0;
  min-width: 120px;
  border-radius: 0.6rem;
  padding: 0.55rem 0.6rem;
  background-color: #f8f9fa;
}

.flow-box.pending {
  border-left: 3px solid #ffc107;
}

.flow-box.rejected {
  border-left: 3px solid #dc3545;
}

.flow-box.done {
  border-left: 3px solid #28a745;
}

.flow-box.flow-split {
  border-left: 3px solid #17a2b8;
}

.flow-label {
  font-size: 0.78rem;
  font-weight: 500;
  margin-bottom: 0.15rem;
}

.flow-money {
  font-weight: 600;
  font-size: 0.9rem;
}

.flow-count {
  font-size: 0.75rem;
  color: #777;
}

.flow-arrow {
  text-align: center;
  font-size: 1rem;
  color: #adb5bd;
  margin: 0.25rem 0;
}

/* Responsive */
@media (max-width: 767.98px) {
  .card-header {
    padding: 0.5rem 0.75rem;
  }
  .card-body {
    padding: 0.75rem;
  }
  .mini-stat .card-body {
    padding: 0.75rem 0.9rem;
  }
}
</style>
